import SectionHeading from '@/components/base/SectionHeading';
import Reveal from '@/components/base/Reveal';
import { accent } from '@/components/feature/solution/theme';

interface ConceptCard {
  icon: string;
  title: string;
  desc: string;
}

interface ParkingConceptProps {
  data: {
    eyebrow: string;
    title: string;
    definition: string;
    cards: ConceptCard[];
    tags: string[];
  };
}

export default function ParkingConcept({ data }: ParkingConceptProps) {
  const a = accent('gold');

  return (
    <section id="concept" className="w-full px-4 md:px-6 py-16 md:py-24 bg-background-50 scroll-mt-20">
      <div className="max-w-[1200px] mx-auto">
        <SectionHeading eyebrow={data.eyebrow} title={data.title} />

        {/* 三列大卡 */}
        <div className="mt-10 grid grid-cols-1 md:grid-cols-3 gap-5">
          {data.cards.map((card, idx) => (
            <Reveal key={card.title} delay={idx * 80}>
              <div className="h-full rounded-2xl border border-background-200 bg-background-100 p-6 md:p-8 transition-all duration-300 hover:-translate-y-1.5 hover:border-secondary-300">
                <span className={`w-14 h-14 flex items-center justify-center rounded-xl ${a.iconBox}`}>
                  <i className={`${card.icon} text-3xl`}></i>
                </span>
                <h3 className="mt-5 font-heading font-bold text-foreground-950 text-xl">{card.title}</h3>
                <p className="mt-3 text-sm text-foreground-600 leading-relaxed">{card.desc}</p>
              </div>
            </Reveal>
          ))}
        </div>

        {/* 三化小条 */}
        <Reveal className="mt-6" delay={120}>
          <div className="flex flex-wrap items-center justify-center gap-3">
            {data.tags.map((tag) => (
              <span
                key={tag}
                className="inline-flex items-center gap-2 px-5 py-2.5 rounded-full bg-secondary-100 text-secondary-900 border border-secondary-200 text-sm whitespace-nowrap"
              >
                <i className="ri-checkbox-circle-line"></i>
                {tag}
              </span>
            ))}
          </div>
        </Reveal>
      </div>
    </section>
  );
}